import { render, staticRenderFns } from "./CompleteStudyInTimeCard.vue?vue&type=template&id=7572cf90&scoped=true"
import script from "./CompleteStudyInTimeCard.vue?vue&type=script&lang=ts"
export * from "./CompleteStudyInTimeCard.vue?vue&type=script&lang=ts"
import style0 from "./CompleteStudyInTimeCard.vue?vue&type=style&index=0&id=7572cf90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572cf90",
  null
  
)

export default component.exports